import React from "react";
import style from "./WelcomeToUs.module.css";
import { Title } from "../Title";
import { Button } from "../../ui";
import { RouteNames } from "../../router";

export const WelcomeToUs = () => {
  return (
    <div className={style.welcomeToUsWrapper}>
      <div className={"container"}>
        <Title title="Welcome to us" />
        <div className={style.welcomeToUsTextContainer}>
          <p className={style.welcomeToUsText}>
            Your kitchen should feel personal, functional, and entirely at home
            in your space. We combine your ideas with our experience to create
            custom cabinetry that fits your lifestyle, daily routines, and
            design preferences.
          </p>
          <p className={style.welcomeToUsText}>
            We work with carefully selected materials and dependable hardware
            to deliver a custom kitchen that looks beautiful and performs
            reliably for years.
          </p>
        </div>
        <Button text={"Schedule a visit"} path={RouteNames.CONTACTS} />
      </div>
    </div>
  );
};
